<template>
    <div class="clients">
        <div v-for="client in myClients" :key="client.name" class="image">
            <img :src="'./images/' + client.name + '_' + ($parent.darkMode ? 'dark' : 'light') + '.png'" :alt=client.name />
        </div>
    </div>
</template>

<script>
    export default {
        name: "Clients",
        props: ['myClients']
    }
</script>

<style lang="sass" scoped>
    .clients
        position: relative
        display: flex
        flex-direction: row
        width: 100%
        padding: 0 152px

        flex-wrap: nowrap
        justify-content: space-between
        align-items: center

        margin-top: -25vh
        margin-top: calc(var(--vh, 1vh) * -25)

        .image
            margin: 20px

            img
                max-width: 100px
                flex-shrink: 0

            &:nth-child(2) // riskified
              img
                max-width: 150px

    @media screen and (max-width: $mobile-break-point)
        .clients
            position: relative
            flex-wrap: wrap
            padding: 0
            justify-content: center
            margin-top: -20vh
            margin-top: calc(var(--vh, 1vh) * -20)

            .image
                flex: 50%
                margin: 50px 0

                img
                    width: 100px
                    margin: 0 auto
</style>